import { ButtonText } from "components/Atoms/Button";
import React from "react";

interface ButtonProps {
  label?: string;
  onClick: () => void;
}

interface Props {
  canCreateNew?: boolean;
  newButton: ButtonProps;
  selectButton: ButtonProps;
  hasError: boolean;
}

export const SelectOrNew = (props: Props) => {
  return <>
    <ButtonText
      navigationGroup="modelPickerButton"
      className="no-padding"
      label={props.selectButton.label ?? RESX.Buttons.btnSelect}
      onClick={props.selectButton.onClick}
      htmlType="button"
      style={{ color: props.hasError ? "var(--error-color)" : undefined, minWidth: 0 }}
    />
    {props.canCreateNew && <>
      &nbsp;|&nbsp;
      <ButtonText
        navigationGroup="modelPickerButton"
        className="no-padding"
        label={props.newButton.label ?? RESX.Buttons.btnNew}
        onClick={props.newButton.onClick}
        htmlType="button"
        style={{ color: props.hasError ? "var(--error-color)" : undefined, minWidth: 0 }}
      />
    </>}
  </>
}
